import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { _SalesOrderEvent } from "../../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";

interface Props {
    idSelector?: number | null;
    onChange: (value: number | null) => void;
    label?: string;
    disable?: boolean;
}

export const SalesOrderOperationEditor = ({ idSelector, onChange, label, disable }: Props) => {
    const { instance, lista, setLista } = useDataBean(_SalesOrderEvent);
    const [id, setID] = useState<number | "">(idSelector ?? "");

    useEffect(() => {
        instance.getSalesOrderOperations(null).then((resp: any) => {
            setLista(resp ?? []);
        }).catch((err: any) => {
            toast.error(err);
        });
    }, []);

    useEffect(() => {
        setID(idSelector ?? "");
    }, [idSelector]);

    const setValue = (value: string) => {
        const selectedValue = value === "" ? null : Number(value);
        setID(value === "" ? "" : selectedValue);
        onChange(selectedValue);
    };

    return (
        <>
            <label>{label ?? "Tipo de Evento"}</label>
            <select
                className="form-select"
                disabled={disable}
                value={id}
                onChange={(e) => setValue(e.target.value)}
            >
                <option value="">...</option>
                {lista.map((item: any, index: number) => (
                    <option key={index} value={item.DataBeanProperties.Value}>
                        {item.DataBeanProperties.Property}
                    </option>
                ))}
            </select>
        </>
    );
};
